// CHEQUE_BOUNCE_LIST get
export const CHEQUE_BOUNCE_LIST_REQUEST = "CHEQUE_BOUNCE_LIST_REQUEST";
export const CHEQUE_BOUNCE_LIST_SUCCESS = "CHEQUE_BOUNCE_LIST_SUCCESS";
export const CHEQUE_BOUNCE_LIST_FAIL = "CHEQUE_BOUNCE_LIST_FAIL";

export const CHEQUE_BOUNCE_LIST_CLEAR_ERROR = "CHEQUE_BOUNCE_LIST_CLEAR_ERROR";